import * as React from "react"
import tw from 'twin.macro'

function Chevron(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none">
      <path d="M0.99996 0.949747L5.94971 5.89949L10.8995 0.949747" stroke="white"/>
      </svg>
  )
}

export default Chevron
